import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOrderLastSelectedState } from '~/types/order/models'

const apiEntityPath = '/api/orderlastselectedstates'

export async function createOrderLastSelectedState(
  entity: IOrderLastSelectedState
) {
  const callingMn = createOrderLastSelectedState.name
  const apiPath = apiEntityPath
  return httpPost<IOrderLastSelectedState>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateOrderLastSelectedState(
  entityData: Partial<IOrderLastSelectedState>,
  id: TEntityId
) {
  const callingMn = updateOrderLastSelectedState.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOrderLastSelectedState = Partial<IOrderLastSelectedState>
  return httpPatchMerge<TPartialOrderLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderLastSelectedState(
  entityData: IOrderLastSelectedState
) {
  const callingMn = deleteOrderLastSelectedState.name
  const apiPath = apiEntityPath
  return httpDelete<IOrderLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}
